module.exports = __webpack_public_path__ + "img/메이지피스트.d53ef032.png";